export enum SortType {
  Asc = 'asc',
  Desc = 'desc'
}
